var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "companies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_line_style_24px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    id: "apartment_FILL0_wght400_GRAD0_opsz24_1_",
    "data-name": "apartment_FILL0_wght400_GRAD0_opsz24 (1)",
    d: "M121.778-824a1.712,1.712,0,0,1-1.256-.522,1.712,1.712,0,0,1-.522-1.256v-8.889a1.712,1.712,0,0,1,.522-1.256,1.712,1.712,0,0,1,1.256-.522h1.778v-1.778a1.712,1.712,0,0,1,.522-1.256,1.712,1.712,0,0,1,1.256-.522h5.333a1.712,1.712,0,0,1,1.256.522,1.712,1.712,0,0,1,.522,1.256v5.333h1.778a1.712,1.712,0,0,1,1.256.522,1.712,1.712,0,0,1,.522,1.256v5.333a1.712,1.712,0,0,1-.522,1.256,1.712,1.712,0,0,1-1.256.522h-5.333v-3.556h-1.778V-824Zm0-1.778h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Zm3.556,3.556h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Zm3.556,7.111h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Zm3.556,10.667h1.778v-1.778h-1.778Zm0-3.556h1.778v-1.778h-1.778Z",
    transform: "translate(1315 857)",
    fill: "#009fe3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.144731eb2a69866b80956c8154482f28.svg";
export { ForwardRef as ReactComponent };